




























































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetProPagandaInfo} from '../../api/realTime'
@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Number}) id:any;
    searchPopShow = false
    queryform = {
        assessment:'',
        propagandaObject:'',
        date:[]
    }
    created(){
        this.getData()
    }
    get height(){
        return window.innerHeight-220
    }
    async getData(){
        let res = await GetProPagandaInfo({
            patientId:this.id,
            assessment:this.queryform.assessment,
            propagandaObject:this.queryform.propagandaObject,
            startDate:this.formatDate(this.queryform.date[0]),
            endDate:this.formatDate(this.queryform.date[1]),
        })
        this.list = res.data
    }
    detailShow = false
    detailData = {}
    list = []
    columns = [
        {title:'宣教时间',key:'formulateDate'},
        {title:'宣教内容',key:'dialysisFrequency',width:800},
        {title:'宣教对象',key:'treatmentCode'},
        {title:'宣教医护',key:'description'},
        {title:'宣教评价',key:'calciumConcetration'},
    ]
}
